import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { Calendar } from 'lucide-react';
import '../../Styles/yellowcalfcss/PayBill.css';
const billsList = [
  { id: 1, billNumber: 'wwxxzz', supplier: '', billDate: '2024-04-03', dueDate: '2024-04-14', paidAmount: 0, totalAmount: 0 },
  { id: 2, billNumber: 'wefg', supplier: '', billDate: '2024-05-23', dueDate: '2024-05-13', paidAmount: 0, totalAmount: 0 },
  { id: 3, billNumber: 'wefg', supplier: '', billDate: '2024-05-23', dueDate: '2024-05-13', paidAmount: 0, totalAmount: 20 }
];

export function PayBill() {
  const [paymentDate, setPaymentDate] = useState('');
  const [selectedBank, setSelectedBank] = useState('');
  const [totalAmountPayable, setTotalAmountPayable] = useState('20');

  const totalAmount = billsList.reduce((sum, bill) => sum + bill.totalAmount, 0);
  const paidAmount = billsList.reduce((sum, bill) => sum + bill.paidAmount, 0);
  const pendingAmount = totalAmount - paidAmount;

  const handleCreate = () => {
    console.log('Creating payment...');
    alert('Well done Bill Payment done successfully');
  };

  return (
    <div className="paybill-main-wrapper">
      <div className="paybill-content-container">
        <div className="paybill-section-gap">
          <Card className="paybill-title-card">
            <Card.Body>
              <h3 className="paybill-main-heading">Pay Bill</h3>
            </Card.Body>
          </Card>
        </div>

        <div className="paybill-section-gap">
          <Card className="paybill-form-card">
            <Card.Body>
              <Container fluid>
                <Row>
                  <Col md={6}>
                    <Form.Group className="paybill-input-group">
                      <Form.Label className="paybill-label">Payment Date</Form.Label>
                      <div className="paybill-calendar-wrapper">
                        <Form.Control
                          type="date"
                          value={paymentDate}
                          onChange={(e) => setPaymentDate(e.target.value)}
                          className="paybill-date-field"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="paybill-input-group">
                      <Form.Label className="paybill-label">
                        Bank <span className="paybill-mandatory">*</span>
                      </Form.Label>
                      <Form.Select
                        value={selectedBank}
                        onChange={(e) => setSelectedBank(e.target.value)}
                        className="paybill-bank-select"
                      >
                        <option value="">Select</option>
                        <option value="bank1">Shamnanda(438756475647)</option>
                        <option value="bank2">aksharban(75475647856478)</option>
                        <option value="bank3">akbarshan(848578475)</option>
                        <option value="bank4">sahensha(495844544)</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
       

        <div className="paybill-section-gap">
          <div className="paybill-bills-collection">
            <Card className="paybill-table-header-card">
              <Card.Body className="paybill-table-header-body">
                <Row className="paybill-header-row">
                  <Col md={1} className="paybill-header-col">#</Col>
                  <Col md={2} className="paybill-header-col">Bill Number</Col>
                  <Col md={2} className="paybill-header-col">Supplier</Col>
                  <Col md={2} className="paybill-header-col">Bill Date</Col>
                  <Col md={2} className="paybill-header-col">Due Date</Col>
                  <Col md={2} className="paybill-header-col">Paid Amount</Col>
                  <Col md={1} className="paybill-header-col">Total Amount</Col>
                </Row>
              </Card.Body>
            </Card>
            {billsList.map((bill) => (
              <Card key={bill.id} className="paybill-bill-row-card">
                <Card.Body className="paybill-bill-row-body">
                  <Row className="paybill-bill-row">
                    <Col md={1} className="paybill-bill-col">{bill.id}</Col>
                    <Col md={2} className="paybill-bill-col">{bill.billNumber}</Col>
                    <Col md={2} className="paybill-bill-col">{bill.supplier || '-'}</Col>
                    <Col md={2} className="paybill-bill-col">{bill.billDate}</Col>
                    <Col md={2} className="paybill-bill-col">{bill.dueDate}</Col>
                    <Col md={2} className="paybill-bill-col">{bill.paidAmount}</Col>
                    <Col md={1} className="paybill-bill-col">
                      {bill.totalAmount === 0 ? '0' : `$ ${bill.totalAmount}`}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>

        <div className="paybill-section-gap">
          <Card className="paybill-summary-card">
            <Card.Body>
              <Container fluid>
                <Row>
                  <Col md={4}>
                    <Form.Group className="paybill-input-group">
                      <Form.Label className="paybill-label">Total Amount Payable *</Form.Label>
                      <Form.Control
                        type="text"
                        value={totalAmountPayable}
                        onChange={(e) => setTotalAmountPayable(e.target.value)}
                        className="paybill-amount-input"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="paybill-input-group">
                      <Form.Label className="paybill-label">Pending Amount</Form.Label>
                      <div className="paybill-amount-display">
                        {pendingAmount} $
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="paybill-input-group">
                      <Form.Label className="paybill-label">Paid Amount</Form.Label>
                      <div className="paybill-amount-display">
                        {paidAmount} $
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </div> </div>

        <div className="paybill-section-gap">
          <Card className="paybill-action-card">
            <Card.Body>
              <div className="paybill-button-wrapper">
                <Button onClick={handleCreate} className="paybill-submit-btn">
                  Create
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}
